import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyMerchantState } from '../reducers';

export const getMerchantState = createSelector(
  getDragonflyMerchantState,
  (state) => state.merchantSearch,
);

export const getPanelExpanded = createSelector(
  getMerchantState,
  ({ panelExpanded }) => panelExpanded,
);

export const getCompanyValues = createSelector(
  getMerchantState,
  ({ companyNameValues }) => companyNameValues,
);

export const getCompanyName = createSelector(getMerchantState, ({ companyName }) => companyName);

export const getCompanyValuesFiltered = createSelector(
  getCompanyValues,
  getCompanyName,
  (companyValues, companyName) => {
    let companyValuesSorted = [...companyValues];
    if (companyName) {
      companyValuesSorted = companyValues.filter((company) =>
        company.companyName.toLowerCase().includes(companyName.toLowerCase()),
      );
    }
    if (companyValuesSorted.length)
      companyValuesSorted.sort((a, b) => a.companyName.localeCompare(b.companyName));
    return companyValuesSorted;
  },
);

export const getSubscriptionPlanValues = createSelector(
  getMerchantState,
  ({ subscriptionPlanValues }) => subscriptionPlanValues,
);

export const getSubscriptionPlan = createSelector(
  getMerchantState,
  ({ subscriptionPlan }) => subscriptionPlan,
);

export const getRegistrationDateFrom = createSelector(
  getMerchantState,
  ({ registrationDateFrom }) => registrationDateFrom,
);

export const getRegistrationDateFromText = createSelector(
  getMerchantState,
  ({ registrationDateFromText }) => registrationDateFromText,
);

export const getQivosID = createSelector(getMerchantState, ({ qivosID }) => qivosID);

export const getMemberStatus = createSelector(getMerchantState, ({ memberStatus }) => memberStatus);

export const getVATNumber = createSelector(getMerchantState, ({ vatNumber }) => vatNumber);

export const getVATNumberRegexValidation = createSelector(getMerchantState, ({ vatNumber }) => {
  if (!vatNumber) {
    return false;
  }

  const cleanedVat = vatNumber.trim();

  const isValid = /^[A-Za-zΑ-Ωα-ω0-9]{1,15}$/.test(cleanedVat);

  return !isValid;
});

export const getImportDateFromValidation = createSelector(
  getRegistrationDateFrom,
  (registrationDateFrom) =>
    registrationDateFrom?.toISOString() !== new Date(0).toISOString() ? registrationDateFrom : '',
);

export const getMainPageStatus = createSelector(getMerchantState, ({ mainPage }) => mainPage);

export const getEditPageStatus = createSelector(getMerchantState, ({ mainPage }) => !mainPage);

export const getCanSearchMerchants = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('merchants.search') ? false : true,
);

export const getCanSeeMerchantCompanyNames = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('merchants.companynames.view') ? false : true,
);

export const getCanViewMerchantSubscriptionPlans = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('merchants.subscriptions.view') ? false : true,
);

export const getDisableSearch = createSelector(
  getCanSearchMerchants,
  getVATNumberRegexValidation,
  (canSearchMerchants, vatNumberRegexValidation) => canSearchMerchants || vatNumberRegexValidation,
);
